export default function calloutMap(userInfo) {
  if (userInfo === undefined) {
    return []
  }

  const showFreeTrialCallout = userInfo.trialing

  const showCreatorUpgradeCallout =
    !showFreeTrialCallout && userInfo.access_level === "creator_free"

  const showNewsletterTrialCallout =
    showFreeTrialCallout && userInfo.access_level === "newsletter_paid"

  const showNewsletterUpgradeCallout =
    !showFreeTrialCallout && userInfo.access_level === "newsletter_free"

  const showCreatorProCallout =
    !showFreeTrialCallout &&
    userInfo.access_level !== "creator_free" &&
    (userInfo.pro_is_purchasable || userInfo.switch_trial_to_pro)

  const showProTrialCallout =
    userInfo.trialing && userInfo.access_level === "creator_pro"

  const calloutMapping = {
    NewsletterTrialCallout: {
      calloutLink: "/upgrade",
      calloutContent: {
        header: "You're on a Newsletter Plan free trial!",
        text:
          "Add your credit card information to keep all the features you have access to without interruption.",
        buttonText: "Upgrade now",
        trackEvent: "main-menu-upgrade-newsletter-trial"
      }
    },
    NewsletterUpgradeCallout: {
      calloutLink: "/account/upgrade",
      calloutContent: {
        header: "Save time with automations",
        text:
          "Explore our plans to access powerful automation tools that’ll give you back time and help you scale your business.",
        buttonText: "Learn more",
        trackEvent: "main-menu-upgrade-newsletter"
      }
    },
    freeTrialCallout: {
      calloutLink: "/upgrade",
      calloutContent: {
        header: "You're on a Creator Plan free trial!",
        text:
          "Upgrade to continue to use all the features you have access to without interruption.",
        buttonText: "Upgrade now",
        trackEvent: "main-menu-upgrade-creator-trial"
      }
    },
    creatorProTrialCallout: {
      calloutLink: "/upgrade",
      calloutContent: {
        header: "You're on a Creator Pro free trial!",
        text:
          "Upgrade to continue to use all the features you have access to without interruption.",
        buttonText: "Upgrade now",
        trackEvent: "main-menu-upgrade-creator-pro-trial"
      }
    },
    creatorProCallout: {
      calloutLink: "/creator_pro",
      calloutContent: {
        header: "Level up your marketing",
        text: `Upgrade to Creator Pro for an extra ${userInfo.creator_pro_pricing_display} to access even more powerful tools to scale your business.`,
        buttonText: "Learn more",
        trackEvent: "main-menu-upgrade-creator-pro"
      }
    },
    creatorUpgradeCallout: {
      calloutLink: "/account_settings/billing",
      calloutContent: {
        header: "Ready to automate your work?",
        text:
          "Upgrade to the Creator Plan to access powerful automation tools to scale your business.",
        buttonText: "Learn more",
        trackEvent: "main-menu-upgrade-creator"
      }
    }
  }

  let calloutVariant = undefined
  const showCallout =
    userInfo.can_view_settings && userInfo.show_upgrade_callout

  if (showProTrialCallout) {
    calloutVariant = "creatorProTrialCallout"
  } else if (showNewsletterTrialCallout) {
    calloutVariant = "NewsletterTrialCallout"
  } else if (showNewsletterUpgradeCallout) {
    calloutVariant = "NewsletterUpgradeCallout"
  } else if (showFreeTrialCallout) {
    calloutVariant = "freeTrialCallout"
  } else if (showCreatorProCallout) {
    calloutVariant = "creatorProCallout"
  } else if (showCreatorUpgradeCallout) {
    calloutVariant = "creatorUpgradeCallout"
  }

  if (calloutVariant && showCallout) {
    return [
      showCallout,
      calloutMapping[calloutVariant]["calloutLink"],
      calloutMapping[calloutVariant]["calloutContent"]
    ]
  } else {
    return []
  }
}
